(ns practitest.frontend.kanban.db
  (:require
    [cljs.spec.alpha :as s]))

(s/def :kanban.db/db (s/keys :req []))

(def default-value {:mode              :main
                    :cart-types-filter "none"
                    :user-list         {:show?      false
                                        :show-idle? false}
                    :action-log        {:show?   false
                                        :actions '()}})

(defn reassign-position [items]
  (map-indexed (fn [i item]
                 (assoc item :position (inc i)))
               items))

(defn ->map [key-fn items]
  (->> items
       (map (fn [item]
              [(key-fn item) item]))
       (into {})))

(defn parse-card-id [card-id]
  (let [[_ entity system-id] (re-find #"^([^:]+):(.*)$" card-id)
        system-id (js/parseInt system-id)]
    [entity system-id]))

(defn move-card [lanes source destination]
  (let [[entity system-id] (parse-card-id (:card-id source))
        card (get-in lanes [(:lane-id source)
                            :cards
                            [entity system-id]])]
    (-> lanes
        (update-in [(:lane-id source) :cards]
                   (fn [cards]
                     (->> (vals (dissoc cards [entity system-id]))
                          (sort-by :position)
                          reassign-position
                          (->map (juxt :entity :system_id)))))
        (update-in [(:lane-id destination) :cards]
                   (fn [cards]
                     (let [ix (dec (:position destination))
                           cs (vec (sort-by :position (vals cards)))]
                       (->> (cond
                              (zero? ix)
                              (vec (cons card cs))

                              (>= ix (:position (last cs)))
                              (vec (conj cs card))

                              :else
                              (vec (concat (subvec cs 0 ix) [card] (subvec cs ix))))
                            reassign-position
                            (->map (juxt :entity :system_id)))))))))

(defn remove-card [lane card-id]
  (let [[entity system-id] (parse-card-id card-id)]
    (update lane :cards
            (fn [cards]
              (->> (vals (dissoc cards [entity system-id]))
                   (sort-by :position)
                   reassign-position
                   (->map (juxt :entity :system_id)))))))

(defn move-lane [lanes lane-id position]
  (let [lane-id (js/parseInt lane-id)
        lane (get lanes lane-id)
        ls (vec (sort-by :position (vals (dissoc lanes lane-id))))
        ix (dec position)]
    (->> (cond
           (zero? ix)
           (vec (cons lane ls))

           (>= ix (:position (last ls)))
           (vec (conj ls lane))

           :else
           (vec (concat (subvec ls 0 ix) [lane] (subvec ls ix))))
         reassign-position
         (->map :id))))

(def max-actions 100)

(defn append-action-log [db message]
  (update-in db [:action-log :actions]
             (fn [actions]
               (take max-actions (conj actions message)))))

(defn remove-entity-from-all-lanes [db k]
  (update db :kanban/lanes
          (fn [lanes]
            (->> lanes
                 (map (fn [[id lane]]
                        [id (update lane :cards dissoc k)]))
                 (into {})))))
